import * as yup from "yup";
import { Alert, Button, FloatingLabel, Form, InputGroup, Spinner } from "react-bootstrap";
import { Default, Mobile } from "../../components/Devices";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { useAuth } from "../../services/wp.auth.service";
import { useCallback } from "react";

import MagicLinkButton from "./MagicLinkButton";
import PasswordWithShow from "../../components/PasswordWithShow";

const errorMessages = {
	// eslint-disable-next-line key-spacing, camelcase
	invalid_email : "Invalid email address and/or password combination.",
	// eslint-disable-next-line key-spacing, camelcase
	incorrect_password: "Invalid email address and/or password combination."
};

const schema = yup.object().shape({
	email: yup.string().email("Must be a valid email address.").
		required("Please enter you account email address."),
	password: yup.string().required()
});
const LoginForm = ({
	className
}) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { login } = useAuth();
	const from = location.state?.from?.pathname || "/";
	const onSubmit = useCallback((values, actions) => {
		login(values).
			then(() => {
				navigate(from);
			}).
			catch((error) => {
				actions.setFieldError("general", errorMessages[error.message] || error.message);
			}).
			finally(() => {
				actions.setSubmitting(false);
			});
	}, [navigate]);

	return (
		<Formik
			initialValues={{
				email: "",
				password: ""
			}}
			onSubmit={onSubmit}
			validationSchema={schema}
		>
			{({
				errors,
				handleBlur,
				handleChange,
				handleSubmit,
				isSubmitting,
				touched,
				values
			}) => (
				<Form className={className} noValidate onSubmit={handleSubmit}>
					<InputGroup className="w-100">
						<FloatingLabel
							className="flex-fill"
							controlId="formBasicEmail"
							label="Email Address *"
						>
							<Form.Control
								// eslint-disable-next-line react/jsx-no-leaked-render
								isInvalid={touched.email && errors.email}
								// eslint-disable-next-line react/jsx-no-leaked-render
								isValid={touched.email && !errors.email}
								name="email"
								onBlur={handleBlur}
								onChange={handleChange}
								placeholder="Email Address *"
								required
								type="email"
								value={values.email}
							/>
						</FloatingLabel>

						<Default>
							<MagicLinkButton
								email={values.email}
								redirect={from}
							/>
						</Default>
					</InputGroup>

					{errors.email ? (
						<Form.Control.Feedback style={{ display: "block" }} type="invalid">
							{errors.email}
						</Form.Control.Feedback>
					) : null}

					<Mobile>
						<div className="d-grid gap-2 pt-3">
							<MagicLinkButton
								className="w-100"
								email={values.email}
								redirect={from}
							/>
						</div>
					</Mobile>

					<PasswordWithShow
						className="my-3"
						// eslint-disable-next-line react/jsx-no-leaked-render
						isInvalid={touched.password && errors.password}
						// eslint-disable-next-line react/jsx-no-leaked-render
						isValid={touched.password && !errors.password}
						name="password"
						onBlur={handleBlur}
						onChange={handleChange}
						placeholder="Password"
						required
						value={values.password}
					/>

					{errors.password ? (
						<Form.Control.Feedback className="d-block mb-3" type="invalid">
							{errors.password}
						</Form.Control.Feedback>) : null}

					{ errors.general ? <Alert variant="danger">{errors.general}</Alert> : null}

					<Button className="w-100 w-md-auto" disabled={isSubmitting} type="submit" variant="primary">
						{isSubmitting ? <Spinner animation="border" size="sm" /> : "Submit"}
					</Button>
				</Form>
			)}
		</Formik>
	);
};

LoginForm.propTypes = {
	className: PropTypes.string
};

LoginForm.defaultProps = {
	className: ""
};

export default LoginForm;
